(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["upshift-core"] && !Shopify.designMode) return;
  try {
    
const observer = new IntersectionObserver((entries) => {
  entries.forEach((entry) => {
    if (entry.isIntersecting) {
      entry.target.classList.add('visible');
      observer.unobserve(entry.target);
    }
  });
}, { threshold: 0.12 });

document.querySelectorAll('.reveal').forEach((el) => observer.observe(el));

const products = {
  money: {
    label: 'UPSHIFT MONEY TRACKER',
    titleLead: 'MAKE EVERY MONTH MAKE ',
    titleAccent: 'SENSE.',
    description: 'Track income and expenses, plan category budgets, and see exactly where your money goes in one customizable Google Sheets tracker.',
    metrics: [
      ['12-MONTH VIEW', 'See the full year at a glance.'],
      ['CUSTOM BUDGETS', 'Plan every category your way.'],
      ['NO-SPEND TRACKING', 'Build better spending habits.']
    ],
    screenshots: [
      ['https://cdn.shopify.com/s/files/1/0813/9918/5649/files/upshift-money-transactions-dashboard-v2.png?v=1789970537', 'Transactions', 'UPSHIFT Money transactions dashboard'],
      ['https://cdn.shopify.com/s/files/1/0813/9918/5649/files/upshift-money-finance-summary-dashboard-v2.png?v=1789970506', 'Finance Summary', 'UPSHIFT Money finance summary dashboard'],
      ['https://cdn.shopify.com/s/files/1/0813/9918/5649/files/upshift-money-financial-dashboard-overview-v2.png?v=1789970527', 'Dashboard Overview', 'UPSHIFT Money financial dashboard overview'],
      ['https://cdn.shopify.com/s/files/1/0813/9918/5649/files/upshift-money-annual-finance-dashboard-summary-v2.png?v=1789970448', 'Annual Summary', 'UPSHIFT Money annual finance dashboard summary'],
      ['https://cdn.shopify.com/s/files/1/0813/9918/5649/files/upshift-money-budget-control-financial-dashboard-v2.png?v=1789970471', 'Budget Control', 'UPSHIFT Money budget control dashboard'],
      ['https://cdn.shopify.com/s/files/1/0813/9918/5649/files/upshift-money-budget-planning-dashboard-v2.png?v=1789970497', 'Budget Planning', 'UPSHIFT Money budget planning dashboard'],
      ['https://cdn.shopify.com/s/files/1/0813/9918/5649/files/upshift-money-where-you-spend-v2.png?v=1789970571', 'Where You Spend', 'UPSHIFT Money spending breakdown dashboard'],
      ['https://cdn.shopify.com/s/files/1/0813/9918/5649/files/upshift-money-financial-goals-v2.png?v=1789970479', 'Financial Goals', 'UPSHIFT Money financial goals dashboard'],
      ['https://cdn.shopify.com/s/files/1/0813/9918/5649/files/upshift-money-no-spend-v2.png?v=1789970515', 'No-Spend', 'UPSHIFT Money no-spend tracker'],
      ['https://cdn.shopify.com/s/files/1/0813/9918/5649/files/upshift-money-recurring-transactions-v2.png?v=1789970552', 'Recurring Transactions', 'UPSHIFT Money recurring transactions tracker'],
      ['https://cdn.shopify.com/s/files/1/0813/9918/5649/files/upshift-money-smart-calendar-v2.png?v=1789970561', 'Smart Calendar', 'UPSHIFT Money smart calendar'],
      ['https://cdn.shopify.com/s/files/1/0813/9918/5649/files/upshift-money-personal-finance-setup-v2.png?v=1789970545', 'Setup', 'UPSHIFT Money personal finance setup dashboard'],
      ['https://cdn.shopify.com/s/files/1/0813/9918/5649/files/upshift-money-financial-tracker-instructions-menu-v2.png?v=1789970489', 'Instructions', 'UPSHIFT Money tracker instructions menu']
    ]
  },
  habits: {
    label: 'UPSHIFT HABITS TRACKER',
    titleLead: 'BUILD HABITS THAT ',
    titleAccent: 'LAST.',
    description: 'Set flexible schedules, check in from one simple daily view, and follow your streaks, completion rates, and long-term patterns.',
    metrics: [
      ['DAILY CHECK-IN', 'Log every habit in one place.'],
      ['FLEXIBLE SCHEDULES', 'Track habits only when planned.'],
      ['MONTH + YEAR VIEWS', 'See streaks and long-term patterns.']
    ],
    screenshots: [
      ['https://cdn.shopify.com/s/files/1/0813/9918/5649/files/upshift-habits-today-v2.png?v=1789970645', 'Today', 'UPSHIFT Habits today view'],
      ['https://cdn.shopify.com/s/files/1/0813/9918/5649/files/upshift-habits-today-part-2-v2.png?v=1789970653', 'Today · Part 2', 'UPSHIFT Habits today view part 2'],
      ['https://cdn.shopify.com/s/files/1/0813/9918/5649/files/upshift-habits-tracker-v2.png?v=1789970663', 'Tracker', 'UPSHIFT Habits tracker'],
      ['https://cdn.shopify.com/s/files/1/0813/9918/5649/files/upshift-habits-tracker-part-2-v2.png?v=1789970672', 'Tracker · Part 2', 'UPSHIFT Habits tracker part 2'],
      ['https://cdn.shopify.com/s/files/1/0813/9918/5649/files/upshift-habits-monthly-tracker-v2.png?v=1789970691', 'Monthly Tracker', 'UPSHIFT Habits monthly tracker'],
      ['https://cdn.shopify.com/s/files/1/0813/9918/5649/files/upshift-habits-yearly-tracker-v2.png?v=1789970699', 'Yearly Tracker', 'UPSHIFT Habits yearly tracker'],
      ['https://cdn.shopify.com/s/files/1/0813/9918/5649/files/upshift-habits-yearly-tracker-part-2-v2.png?v=1789970708', 'Yearly · Part 2', 'UPSHIFT Habits yearly tracker part 2'],
      ['https://cdn.shopify.com/s/files/1/0813/9918/5649/files/upshift-habits-yearly-tracker-part-3-v2.png?v=1789970717', 'Yearly · Part 3', 'UPSHIFT Habits yearly tracker part 3'],
      ['https://cdn.shopify.com/s/files/1/0813/9918/5649/files/upshift-habits-setup-v2.png?v=1789970636', 'Setup', 'UPSHIFT Habits setup'],
      ['https://cdn.shopify.com/s/files/1/0813/9918/5649/files/upshift-habits-instructions-v2.png?v=1789970579', 'Instructions', 'UPSHIFT Habits instructions']
    ]
  }
};

const galleryTabs = [...document.querySelectorAll('.gallery-tabs button')];
const galleryPanel = document.querySelector('#productGallery');
const galleryImage = document.querySelector('#galleryImage');
const galleryTitle = document.querySelector('#galleryTitle');
const galleryCount = document.querySelector('#galleryCount');
const galleryThumbs = document.querySelector('#galleryThumbs');
const productLabel = document.querySelector('#insideProductLabel');
const productTitle = document.querySelector('#insideTitle');
const productDescription = document.querySelector('#insideDescription');
const productMetrics = document.querySelector('#insideMetrics');
let activeProduct = 'money';
let activeScreenshot = 0;

function renderScreenshot() {
  const screenshot = products[activeProduct].screenshots[activeScreenshot];
  galleryImage.src = screenshot[0];
  galleryImage.alt = screenshot[2];
  galleryTitle.textContent = screenshot[1];
  galleryCount.textContent = `${activeScreenshot + 1} / ${products[activeProduct].screenshots.length}`;
  galleryThumbs.querySelectorAll('button').forEach((button, index) => {
    button.classList.toggle('active', index === activeScreenshot);
    button.setAttribute('aria-current', index === activeScreenshot ? 'true' : 'false');
  });
}

function renderThumbnails() {
  galleryThumbs.replaceChildren();
  galleryThumbs.setAttribute('aria-label', `${products[activeProduct].label} screenshots`);
  products[activeProduct].screenshots.forEach((screenshot, index) => {
    const button = document.createElement('button');
    const image = document.createElement('img');
    button.type = 'button';
    button.setAttribute('aria-label', `Show ${screenshot[1]}`);
    image.src = screenshot[0];
    image.alt = '';
    image.loading = 'lazy';
    button.append(image);
    button.addEventListener('click', () => {
      activeScreenshot = index;
      renderScreenshot();
    });
    galleryThumbs.append(button);
  });
}

function renderProduct(productKey, focusTab = false) {
  activeProduct = productKey;
  activeScreenshot = 0;
  const product = products[activeProduct];
  productLabel.textContent = product.label;
  productTitle.replaceChildren(document.createTextNode(product.titleLead));
  const accent = document.createElement('em');
  accent.textContent = product.titleAccent;
  productTitle.append(accent);
  productDescription.textContent = product.description;
  productMetrics.replaceChildren(...product.metrics.map(([heading, detail]) => {
    const card = document.createElement('div');
    const strong = document.createElement('strong');
    const span = document.createElement('span');
    strong.textContent = heading;
    span.textContent = detail;
    card.append(strong, span);
    return card;
  }));
  galleryTabs.forEach((tab) => {
    const isActive = tab.dataset.product === activeProduct;
    tab.classList.toggle('active', isActive);
    tab.setAttribute('aria-selected', String(isActive));
    tab.tabIndex = isActive ? 0 : -1;
    if (isActive) {
      galleryPanel.setAttribute('aria-labelledby', tab.id);
      if (focusTab) tab.focus();
    }
  });
  renderThumbnails();
  renderScreenshot();
}

galleryTabs.forEach((button, index) => {
  button.addEventListener('click', () => renderProduct(button.dataset.product));
  button.addEventListener('keydown', (event) => {
    if (!['ArrowLeft', 'ArrowRight'].includes(event.key)) return;
    event.preventDefault();
    const direction = event.key === 'ArrowRight' ? 1 : -1;
    const nextTab = galleryTabs[(index + direction + galleryTabs.length) % galleryTabs.length];
    renderProduct(nextTab.dataset.product, true);
  });
});

document.querySelector('#galleryPrev').addEventListener('click', () => {
  const total = products[activeProduct].screenshots.length;
  activeScreenshot = (activeScreenshot - 1 + total) % total;
  renderScreenshot();
});

document.querySelector('#galleryNext').addEventListener('click', () => {
  activeScreenshot = (activeScreenshot + 1) % products[activeProduct].screenshots.length;
  renderScreenshot();
});

renderThumbnails();
renderScreenshot();


  } catch(e) { console.error(e); }
})();
})();
